import { date } from './date';
import { datetime } from './datetime';
import { day } from './day';
import { time } from './time';
import { datetimecapital } from './datetimecapital';

export default [
	{ 'name': 'date', 'action': date },
	{ 'name': 'day', 'action': day },
	{ 'name': 'time', 'action': time },
	{ 'name': 'datetime', 'action': datetime },
	{ 'name': 'datetimecapital', 'action': datetimecapital }
];
